@if (notes?.length) {
  @for (note of notes; track note) {
    <div class="py-4">
      <h3 class="pb-2 fw-700 fs-22">
        {{ note.modifiedDate | date: 'short' }} - {{ note.emailAddress }}
      </h3>
      <div class="card">
        <div class="flex justify-between items-center">
          <h4 class="fw-700 fs-16 text-th-primary">
            {{ note.noteType === 'V' ? 'Visit Note' : 'Patient Note' }}
          </h4>
          <span class="float-right buttons">
            <button
              class="px-2 text-md font-medium text-th-primary hover:text-th-hover-primary rounded-md focus:z-10 focus:outline-none disabled:opacity-50"
              (click)="editNote(note)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 pr-1">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                </svg>
              </button>
              <button
                class="text-md font-medium text-th-primary hover:text-th-hover-primary rounded-md focus:z-10 focus:outline-none disabled:opacity-50 float-right"
                (click)="deleteNote(note.noteId)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="w-6 h-6 pr-1"
                  viewBox="0 0 16 16">
                  <path
                    d="M14 3a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2zM3.215 4.207l1.493 8.957a1 1 0 0 0 .986.836h4.612a1 1 0 0 0 .986-.836l1.493-8.957C11.69 4.689 9.954 5 8 5c-1.954 0-3.69-.311-4.785-.793z" />
                  </svg>
                </button>
              </span>
            </div>
            @if (note.mode === 'view') {
              <span>
                <quill-view-html [content]="note.notes"> </quill-view-html>
              </span>
            }
            @if (note.mode === 'edit') {
              <span>
                @if (editForm) {
                  <form
                    [formGroup]="editForm"
                    (ngSubmit)="saveEditedNote()">
                    <quill-editor
                      class="w-100"
                      [format]="'html'"
                      [formControlName]="'note'"
                      [placeholder]="'Enter note'"
                      [sanitize]="false"
                    [modules]="quillConfig"></quill-editor>
                    <div class="flex flex-1 justify-end pt-2">
                      <button
                        type="submit"
                        class="text-th-primary"
              [ngClass]="{
                'text-gray-700': editForm.invalid,
                'hover:text-th-hover-primary': editForm.valid
              }"
                        [disabled]="editForm.invalid">
                        <span>Save</span>
                      </button>
                    </div>
                  </form>
                }
              </span>
            }
          </div>
        </div>
      }
    } @else {
      <h3 class="pt-3 fw-700 fs-22">
        No {{ noteType === 'all' ? '' : noteType }} notes available
      </h3>
    }

